import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalService } from '@app/@core/services/local.service';
import { Subscription, fromEvent } from 'rxjs';
import { startWith } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-otp-confirmation-screen',
  templateUrl: './otp-confirmation-screen.component.html',
  styleUrls: ['./otp-confirmation-screen.component.scss']
})
export class OtpConfirmationScreenComponent implements OnInit, OnDestroy {

    isMobile = false;
    logoPath = 'assets/images/edu-logo.svg';
    resizeObservable$: Subscription | undefined;

  constructor(private readonly router: Router ,private sessionStorage: LocalService,) {}

   ngOnInit(): void {
    this.setupResponsiveImage();
  }

  ngOnDestroy(): void {
    if (this.resizeObservable$) {
      this.resizeObservable$.unsubscribe();
    }
  }

    setupResponsiveImage(): void {
      this.resizeObservable$ = fromEvent(window, 'resize').pipe(startWith({} as Event))
        .subscribe(() => {
          this.isMobile = window.innerWidth < 768;
          this.updateLogoPath();
        });
      
      
      this.isMobile = window.innerWidth < 768;
      this.updateLogoPath();
    }

    updateLogoPath(): void {
    this.logoPath = this.isMobile 
      ? 'assets/images/cardy-ai/mobile-logo.svg'
      : 'assets/images/edu-logo.svg';
  }

  onResetPassword(): void {
    this.router.navigate(['app-login/set-New-Password']);
  }
  onLogIn(): void {
    this.sessionStorage.clear();
    localStorage.clear();
    this.router.navigate(['']);
  }

}
